export type { FragmentType, MaybeMasked, Unmasked } from "./types.js";
export type { GraphQLCodegenDataMasking } from "./GraphQLCodegenDataMasking.js";
export { disableWarningsSlot } from "./utils.js";
export { maskFragment } from "./maskFragment.js";
export { maskOperation } from "./maskOperation.js";
